import React from "react"
import TlkTable from "../tlelrik/table/tlkTable"
import services from "../../services"
import queryString from "query-string"
import ContaTabs from "./ContaTabs"
import { Button } from "@progress/kendo-react-buttons"
import TabsContaDetailsContainer from "./Tabs/TabsContaDetailsContainer"
var moment = require("moment")

const columnKeyMap = {
    // codContaCorrente: 'Nº Conta Corrente',
    dataCriado: "Data de criação",
    descricao: "Tipo de Conta",
    produto: "Produto",
    ano: "Ano",
    distrito: "Saldo",
    //saldoTotal: "Saldo Total",
    saldoGranel: "Não certificado",
    saldoApto: "Indisponível granel",
    saldoEngarrafado: "Indisponível engarrafado",
    comercializado: "Comercializado", // TODO: Ask @Dart for the key *Saldo*
    saldoCativo: "Saldo Cativo",
}

const dateFormat = "YYYY-MM-DD"

const actionbuttons = { CommonRedirection: "Detalhes da Conta" }

class AccountTab extends React.Component {
    constructor() {
        super()

        this.state = {
            loaded: false,
            data: [],
            totalCount: 0,
            columnList: [],
            filters: {
                Filters: { entityId: null },
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        }
    }

    componentDidMount() {
        ;(async () => {
            const queryParams = queryString.parse(this.props.location.search)
            console.log("query params are", queryParams)
            const query = {
                entityId: queryParams.IDInstalacaoVinica,
            }
            const filters = {
                ...this.state.filters,
                Filters: query,
            }
            console.log("accont listing worked... ", filters, this.props)

            const response = await services.apiCall.requestApi(
                "ContaCorrente/GetContasCorrentes",
                filters,
                "post"
            )
            const columnList = Object.keys(columnKeyMap).map((key) => ({
                field: columnKeyMap[key],
                columnMenuType: "checkbox",
            }))

            if (response && response.length > 0) {
                // const data = response.map((entity) => ({
                //   ...Object.keys(columnKeyMap).reduce((acc, key) => {
                //     acc[columnKeyMap[key]] = entity[key]
                //     return acc;
                //   }, {}),
                //   selected: false,
                // }));
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        entity[columnKeyMap[key]] = entity[key]
                        if (key === "dataCriado")
                            entity[columnKeyMap[key]] = entity["dataCriado"]
                                ? moment(entity["dataCriado"]).format(
                                      dateFormat
                                  )
                                : "nd"
                        if (key === "saldoCativo")
                            entity[columnKeyMap[key]] =
                                services.money.format(entity[key]) || 0
                        if (key === "distrito") {
                            entity[columnKeyMap[key]] =
                                services.money.format(entity.saldoDisponivel) ||
                                0
                            // (entity['saldoCertificadoDisponivel'] + entity['saldoCertificadoIndisponivel']
                            //                             + entity['saldoEngarrafadoDisponivel'] + entity['saldoEngarrafadoIndisponivel']
                            //                             + entity['saldoGranelDisponivel'] + entity['saldoGranelIndisponivel'])
                        }
                        if(key === "saldoTotal"){
                            entity[columnKeyMap[key]] = Number(Number(entity["saldoGranel"] ? entity["saldoGranel"] : "") + 
                            Number(entity["saldoApto"] ? entity["saldoApto"] : "") + 
                            Number(entity["saldoEngarrafado"] ? entity["saldoEngarrafado"] : "") +
                            Number(entity["comercializado"] ? entity["comercializado"] : ""))
                        }
                        
                        if(key === "saldoGranel" ||
                        key === "saldoApto" ||
                        key === "saldoEngarrafado"||
                        key === "comercializado") {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0"
                        }
                    }),
                    selected: false,
                }))
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                }))
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }))
            }
        })()
    }

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (selection.dataItem.codContaCorrente === item.codContaCorrente) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true }
            } else {
                return { ...item, selected: false }
            }
        })
        this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                accountId: 0,
            })
            console.log("QPARAMS BEFORE");
            console.log(queryParams);
            this.props.history.push(`/conta_corrente/movements?${queryParams}`)
        })
    }

    ActionPerform = async (action, row) => {
        console.log("Action Perorm", action, "row", row)
        // TODO: Rohit — Export data from grid
        if (action === "Detalhes da Conta") {
            // const data = [...this.state.data].map((item) => {
            //   if (row.idContaCorrente === item.idContaCorrente) { // TODO: Ask @Dart for the unique key to use here
            //     console.log("selected",item);
            //     return { ...item, selected: true };
            //   } else {
            //     return { ...item, selected: false };
            //   }
            // });
            // this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                accountId: row.idContaCorrente,
                tdc: row.descricao,
                pr: row.produto,
                ncc: row.codContaCorrente,
                sa: row.Saldo,
                iva: row.instalacaoVinica,
                idEst: row.idEstatuto,
                idTC: row.idTipoConta,
                sldG: row.saldoGranel,
                sldA: row.saldoApto,
                sldE: row.saldoEngarrafado,
                nrReg: row.numeroRegisto
            });
            console.log("QPARAMS BEFORE");
            console.log(queryParams);
            if (this.props.location.pathname === "/conta_operações/accounts")
                this.props.history.push(
                    `/conta_operações/movements?${queryParams}`
                )
            else
                this.props.history.push(
                    `/conta_corrente/movements?${queryParams}`
                )
            // });
        }
    }

    render() {
        let message = `${this.state.totalCount} Contas Correntes ativas da Entidade na entidade selecionada`

        return (
            <>
                <div className="mt-4">
                    <ContaTabs search={this.props.location.search} />
                    {/* <div className="text-right">
            <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={ () => window.history.back() }>Voltar</Button>
          </div> */}
          <TabsContaDetailsContainer 
                accountDetails={this.accountDetailsToPass()}
                location={this.props.location}
                match={this.props.match}
                entityDetailData={(data) => this.entityDetailData(data)}
                />
                    <div className="table-section custom-k-grid pt-3">
                        <div className="table-responsive">
                            {this.state.loaded && (
                                <>
                                    {/* <span>A pesquisa retornou {this.state.totalCount} registos</span> */}
                                    <TlkTable
                                        date={new Date()}
                                        list={this.state.data}
                                        modulename={"Conta Corrente"}
                                        notAction={false}
                                        notGroup={true}
                                        actionbuttons={actionbuttons}
                                        columnlist={this.state.columnList}
                                        ActionPerform={(action, id) =>
                                            this.ActionPerform(action, id)
                                        }
                                        // selection={ true }
                                        // selectionChange={ (e) => this.selectionChange(e) }
                                        toolbarHTML={message}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default AccountTab
